import {
  SpinHealthWithGames,
  SpinToWinApi,
  TicketScanHealth,
  TicketScansApi,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getSpinHealth = async (
  windowHours: number,
  gameId?: string,
): Promise<SpinHealthWithGames> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SpinToWinApi)
  return await api.getSpinHealth({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    windowHours,
    gameId,
  })
}

const getTicketScanHealth = async (windowHours: number): Promise<TicketScanHealth> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(TicketScansApi)
  return await api.getTicketScanHealth({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    windowHours,
  })
}

export const SystemHealthAPI = {
  getSpinHealth,
  getTicketScanHealth,
}
